import { render, staticRenderFns } from "./Org.vue?vue&type=template&id=1465c8d5&scoped=true&"
import script from "./Org.vue?vue&type=script&lang=js&"
export * from "./Org.vue?vue&type=script&lang=js&"
import style0 from "./Org.vue?vue&type=style&index=0&id=1465c8d5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1465c8d5",
  null
  
)

export default component.exports